import '@arco-design/web-react/dist/css/arco.css';
import { useEffect, useMemo } from 'react';
import { router, onRouterBefore } from '@/router/routes';
import { useRoutes, useLocation } from 'react-router';
import { transformRoutes, setRouteBefore } from '@/router/RouterGuard';
import { useNavigate } from 'react-router-dom';
import useAppStore from './store/appStore';
import { bpThrottle } from './hooks/gHooks/useDeb';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';

function App() {
  const navigate = useNavigate();
  const appStore = useAppStore();

  setRouteBefore(onRouterBefore);
  const elements = useRoutes(transformRoutes(router));

  useEffect(() => {
    appStore.setCurDevice();
    window.onresize = bpThrottle(() => {
      appStore.setCurDevice();
    });
  }, []);

  useEffect(() => {
    const handleTouchStart = (e: any) => {
      let targetElement = e.target; // 获取触摸到的元素
      let foundForbidClass = false;

      // 遍历父元素直到html根元素
      while (targetElement && targetElement !== document.documentElement) {
        if (targetElement.classList.contains('forbid-scroll')) {
          foundForbidClass = true;
          break;
        }
        targetElement = targetElement.parentElement;
      }

      // 如果找到包含'forbid-scroll'类名的父元素，阻止默认行为
      if (foundForbidClass) {
        e.preventDefault();
      }
    };

    // 监听touchstart事件
    window.addEventListener('touchstart', handleTouchStart, { passive: false });

    return () => {
      // 清除事件监听器
      window.removeEventListener('touchstart', handleTouchStart);
    };
  }, []);

  return (
    <>
      <I18nextProvider i18n={i18next}>
        <div className="App h-full bg-#F3F3F6">{elements}</div>
      </I18nextProvider>
    </>
  );
}

export default App;
